import api from '../../../api/index';
import shopkeeperAppApi from '../../../api/shopkeeperAppApi';

export default {
  registerClient({}, value) {
    return api.post('/client', value);
  },
  registeraddress({ rootGetters }, value) {
    return api.put('save-adress', value, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getAdress({ rootGetters }, id) {
    return api.get(`get-adress/${id}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getOrcamento({ }, data) {
    return shopkeeperAppApi.get(`balconista/buscar-orcamento-cliente/${data.id}?token=${data.token}`);
  },
  registerClientApp({}, data) {
    return shopkeeperAppApi.post('/balconista/salvar-cliente', data);
  },
  validCpf({}, data) {
    return shopkeeperAppApi.post('/validar-cpf', data);
  },
  validEmail({}, data) {
    return shopkeeperAppApi.post('/validar-email', data);
  },
  finishClientRegister({ rootGetters }, value) {
    return api.put('finish-client-register', value, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  saveBasicInformation({ rootGetters }, value) {
    return api.put('client/save-basic-information', value, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
};
